import { render, staticRenderFns } from "./HistamineScore.vue?vue&type=template&id=44a0822c&"
import script from "./HistamineScore.vue?vue&type=script&lang=js&"
export * from "./HistamineScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports